import { CommerceService } from "@/services/commerce"

/**
 * Method to retrieve stores with distribution channels
 *
 * @param {array} stores
 *
 * @return {Promise<object>|null}
 */
export const getStoreKeysWithChannels = async (stores) => {
  const commerceApi = CommerceService.api()

  if (!stores || stores.length <= 1) return null

  // having stores in array, we need to form a string and execute the query
  let queryKeys = stores.map(({ key }) => {
    if (!key) return null

    return `"${key}"`
  })

  // remove anything that is null
  queryKeys = queryKeys.filter((n) => n)

  const storeQueryString = queryKeys.join(",")

  const storesWithChannels = (
    await commerceApi
      .stores()
      .get({
        queryArgs: {
          where: `key in (${storeQueryString})`,
        },
      })
      .execute()
  )?.body?.results

  // form the array with store key and channel id
  let storeKeysWithChannels = []
  for (let i = 0; i < storesWithChannels.length; i++) {
    const storeWithChannel = storesWithChannels[i]
    const distributionChannels = storeWithChannel.distributionChannels

    if (distributionChannels.length > 0) {
      for (let j = 0; j < distributionChannels.length; j++) {
        const distributionChannel = distributionChannels[j]

        storeKeysWithChannels.push({
          key: storeWithChannel.key,
          distributionChannelId: distributionChannel.id,
        })
      }
    }
  }

  return storeKeysWithChannels
}
